<template>
  <div>
    <el-form :model="form" :inline="true" size="mini" label-width="100px" class="hidden-xl-only">
      <el-form-item style="float: right;">
        <el-link type="primary" :underline="false" @click="collapse = !collapse;" style="margin-right: 10px;">{{collapse?'折叠':'展开'}}</el-link>
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button type="warning" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="产品编码" prop="productCode">
        <el-input v-model="form.productCode"></el-input>
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input v-model="form.productName"></el-input>
      </el-form-item>
      <el-form-item label="品类" prop="category">
        <el-select v-model="form.category" @change="handleCategoryChange" filterable>
          <el-option :label="item" :value="item" v-for="(item,index) in categorys" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse">
          <el-form-item label="材质" prop="material">
            <el-select v-model="form.material">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in materials" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="颜色" prop="color">
            <el-select v-model="form.color">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in colors" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="尺寸" prop="length">
            <el-select v-model="form.length">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in lengths" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="价格" prop="price">
            <el-select v-model="form.price">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in prices" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销量" prop="saleNum">
            <el-select v-model="form.saleNum">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in saleNums" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <span class="form-date-picker">
            <el-form-item label="上市时间:">
              <el-date-picker
                v-model="form.marketOnStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker
                v-model="form.marketOnEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </span>
        </div>
      </transition>
    </el-form>
    <el-form :model="form" :inline="true" size="mini" label-width="100px" class="hidden-lg-and-down">
      <el-form-item style="float: right;">
        <el-link type="primary" :underline="false" @click="collapse = !collapse;" style="margin-right: 10px;">{{collapse?'折叠':'展开'}}</el-link>
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button type="warning" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="产品编码" prop="productCode">
        <el-input v-model="form.productCode"></el-input>
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input v-model="form.productName"></el-input>
      </el-form-item>
      <el-form-item label="品类" prop="category">
        <el-select v-model="form.category" @change="handleCategoryChange" filterable>
          <el-option :label="item" :value="item" v-for="(item,index) in categorys" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="材质" prop="material">
        <el-select v-model="form.material">
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in materials" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="颜色" prop="color">
        <el-select v-model="form.color">
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in colors" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse">
          <el-form-item label="尺寸" prop="length">
            <el-select v-model="form.length">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in lengths" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="价格" prop="price">
            <el-select v-model="form.price">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in prices" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销量" prop="saleNum">
            <el-select v-model="form.saleNum">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in saleNums" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <span class="form-date-picker">
            <el-form-item label="上市时间:">
              <el-date-picker
                v-model="form.marketOnStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker
                v-model="form.marketOnEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </span>
        </div>
      </transition>
    </el-form>
  </div>
</template>

<script>
const maps = {
  'materials': 1,
  'colors': 2,
  'lengths': 3,
  'prices': 4
}
export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: ['formData'],
  data() {
    return {
      collapse: false,
      form: {},
      categorys: [],
      colors: [],
      lengths: [],
      materials: [],
      prices: [],
      saleNums: [],
    }
  },
  watch: {
    formData: {
      handler(val) {
        // 品类必传，否则接口会报错
        if(val.category) {
          this.form = JSON.parse(JSON.stringify(val));
        }
      },
      deep: true,
      immediate: true
    },
    collapse(val) {
      this.$emit('onCollapse', val);
    }
  },
  mounted() {
    this.get_categoryOpt();
  },
  methods: {
    onSearch() {
      this.$emit('search', this.form)
    },
    onReset() {
      this.form = {
        category: this.$route.query.category,
        material: '',
        color: '',
        length: '',
        price: '',
        saleNum: '',
      };
      this.$nextTick(_=>{
        this.onSearch();
      })
    },
    get_categoryOpt() {
      this.$q.goodsAnalysis.categorySelect()
      .then(res=>{
        this.categorys = res.data || [];
        this.get_anotherOpt();
        this.get_saleNumOpt();
      })
    },
    get_saleNumOpt() {
      return this.$q.goods.listPage({data: {
        filterData: {
          tag: 3, optionType: "36"
        },
        pageNum: 1,
        pageSize: 1000
      }})
      .then(res=>{
        this.saleNums = res.data.records;
      })
    },
    async handleCategoryChange() {
      this.$set(this.form, 'material', '');
      this.$set(this.form, 'color', '');
      this.$set(this.form, 'length', '');
      this.$set(this.form, 'price', '');
      this.$set(this.form, 'saleNum', '');
      this.get_anotherOpt();
    },
    get_anotherOpt() {
      return this.$q.goodsAnalysis.categoryAttr({fragment: [this.form.category]})
      .then(res=>{
        Object.keys(maps).forEach(key=>{
          this.$set(this, key, res.data[maps[key]] || []);
        })
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
  >>> .el-form
    width 100%
    margin-top 5px
  >>> .el-form-item
    margin-bottom 5px !important
  .search-header-collapse 
    // position absolute
    background-color #ffffff
    width 100%
    left 0px
    padding 10px 0 0
    margin-top -5px
    box-sizing border-box
    // z-index 999
    // box-shadow 0px 5px 5px rgba(0,0,0,.1)

  >>> .table-input input
    height 18px
    line-height 18px
    padding 0 10px
    text-align right
    width 45px
</style>